import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  div.pedido-linha {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  strong {
    font-family: ui-monospace, Consolas, "Courier New", monospace;
    font-size: 0.9375rem;
    line-height: 1.5rem;
    font-weight: 700;
    color: var(--principal-50);
  }

  button {
    font-family: ui-monospace, Consolas, "Courier New", monospace;
    font-size: 0.8125rem;
    line-height: 1.25rem;
    font-weight: 700;
    color: var(--cinza-80);
    background: var(--white);
    border: 1px solid var(--cinza-40);
    border-radius: 6px;
    padding: 2px 10px;
    cursor: pointer;
  }

  p {
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--cinza-70);
    margin: 0;
  }
`;
